import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import DeleteForever from "@material-ui/icons/DeleteForever";
import DialogConfirm from "../DialogConfirm";
import {
  IconButton,
  Button
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonDelete({ session, reloadData }) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
 
  return (
    <>
      {session&&(
        <IconButton onClick={handleOnOpen}>
          <DeleteForever/>
        </IconButton>      
      )}      
      <DialogConfirm
        //fullScreen
        open={isDialogOpen}
        onClose={handleOnClose}
        session_id = {session.id}
        reloadData={reloadData}
      />
    </>
  );
}
